import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { getMe, logout, type MeResponse } from "@/lib/api";

export type AuthState = {
  user: MeResponse | undefined;
  isLoading: boolean;
  isAuthenticated: boolean;
  isError: boolean;
  handleLogout: () => Promise<void>;
};

export function useAuth(): AuthState {
  const queryClient = useQueryClient();
  const meQuery = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    retry: false,
  });

  const handleLogout = useCallback(async () => {
    const redirectTo = await logout();
    queryClient.removeQueries({ queryKey: ["me"] });
    queryClient.removeQueries({ queryKey: ["embed"] });
    window.location.assign(redirectTo);
  }, [queryClient]);

  return {
    user: meQuery.data,
    isLoading: meQuery.isLoading,
    isAuthenticated: meQuery.isSuccess,
    isError: meQuery.isError,
    handleLogout,
  };
}
